import { render, staticRenderFns } from "./inventoryMoveList.vue?vue&type=template&id=44774a42&scoped=true"
import script from "./inventoryMoveList.vue?vue&type=script&lang=js"
export * from "./inventoryMoveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44774a42",
  null
  
)

export default component.exports